export { CategoryTabsWithStyles } from './CategoryTabs'
